import api from '../api'
import { splitDataUrl } from '../utils/file'

export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST'
export function uploadImageRequest() {
  return { type: UPLOAD_IMAGE_REQUEST }
}

export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS'
export function uploadImageSuccess(image) {
  return { type: UPLOAD_IMAGE_SUCCESS, image }
}

export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR'
export function uploadImageError(error) {
  return { type: UPLOAD_IMAGE_ERROR, error }
}

export function uploadImage(entity, dataUrl) {
  return dispatch => {
    dispatch(uploadImageRequest())
    const { mimeType, data: fileContent } = splitDataUrl(dataUrl)
    return api
      .uploadImage(entity.type, entity.id, { mimeType, fileContent })
      .then(
        image => {
          dispatch(uploadImageSuccess(image))
        },
        error => {
          dispatch(uploadImageError(error))
        }
      )
  }
}

export function uploadRepImage(retailer, dataUrl) {
  return dispatch => {
    dispatch(uploadImageRequest())
    const { mimeType, data: fileContent } = splitDataUrl(dataUrl)
    return api.uploadRepImage(retailer.id, { mimeType, fileContent }).then(
      image => {
        dispatch(uploadImageSuccess(image))
      },
      error => {
        dispatch(uploadImageError(error))
      }
    )
  }
}

export function uploadMastheadImage(retailer, dataUrl) {
  return dispatch => {
    dispatch(uploadImageRequest())
    const { mimeType, data: fileContent } = splitDataUrl(dataUrl)
    return api.uploadMastheadImage(retailer.id, { mimeType, fileContent }).then(
      image => {
        dispatch(uploadImageSuccess(image))
      },
      error => {
        dispatch(uploadImageError(error))
      }
    )
  }
}

export const DELETE_IMAGE_REQUEST = 'DELETE_IMAGE_REQUEST'
export function deleteImageRequest() {
  return { type: DELETE_IMAGE_REQUEST }
}

export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS'
export function deleteImageSuccess() {
  return { type: DELETE_IMAGE_SUCCESS }
}

export const DELETE_IMAGE_ERROR = 'DELETE_IMAGE_ERROR'
export function deleteImageError(error) {
  return { type: DELETE_IMAGE_ERROR, error }
}
